import {
    AllSecuritiesResponseProto,
    LookupSecuritiesBySymbolResponse,
    SearchSecurityResponse,
    Securities,
    Security,
    SecurityCategories
} from '../../proto/generated/security'
import overviewActions from '../../actions/overview.actions'
import api from './axiosClient'
import { Exchange, exchangeFromJSON, exchangeToJSON } from '../../proto/generated/common'
import { AppDispatch } from '../../store'
import { GetTechnicalsConfigResponse, OverviewWidgetResponse } from '../../proto/generated/overview-widget'
import { getSecurityKey, isValidExchange } from '../../util/security'

export const getCategories = async (): Promise<SecurityCategories> => {
    return new Promise((resolve, reject) => {
        const url = `/securities/categories`
        api.get(url, {
            headers: {
                'Accept': 'application/x-protobuf'
            },
            responseType: 'arraybuffer'
        }).then(async (response) => {
            const decodedData = SecurityCategories.decode(new Uint8Array(response.data))

            resolve(decodedData)
        }).catch((error) => {

            reject(error)
        })
    })
}

export const getAllSecurities = async (): Promise<AllSecuritiesResponseProto> => {
    return new Promise((resolve, reject) => {
        const url = `/v2/security/all`;
        api.get(url, {
            headers: {
                'Accept': 'application/x-protobuf',
            },
            responseType: 'arraybuffer',
            validateStatus: (status) => (status >= 200 && status < 300) || status === 304
        }).then(async (response) => {
            const decodedData = AllSecuritiesResponseProto.decode(new Uint8Array(response.data))
            if(decodedData) {
                resolve(decodedData)
            }
        }).catch((error) => {
            reject(error)
        })
    })
}

export const fetchSecurities = async (securities: {exchange: Exchange, code: string}[]): Promise<Security[]> => {
    return new Promise((resolve, reject) => {
        const url = `/v2/security`
        api.post(url, JSON.stringify({securities: securities}), {
            headers: {
                'Accept': 'application/x-protobuf'
            },
            responseType: 'arraybuffer'
        }).then(async (response) => {
            const decodedData = Securities.decode(new Uint8Array(response.data))
            resolve(decodedData.securities)
        }).catch((error) => {

            reject(error)
        })
    })
}

export const lookupSecurities = async (args: {
    pageNumber: number
    categoryCode: string
    exchange?: string
    searchText: string
    pageSize: number
    hasFo?:boolean
}): Promise<SearchSecurityResponse> => {
    return new Promise((resolve, reject) => {
        const url = `/securities/lookup`
        api.post(url, JSON.stringify(args), {
            headers: {
                'Accept': 'application/x-protobuf'
            },
            responseType: 'arraybuffer'
        }).then(async (response) => {
            const decodedData = SearchSecurityResponse.decode(new Uint8Array(response.data))

            resolve(decodedData)
        }).catch((error) => {

            reject(error)
        })
    })
}

export const getOverviewWidget = async (args: {
    exchange: Exchange,
    code: string,
    dispatch: AppDispatch
}): Promise<OverviewWidgetResponse> => {
    return new Promise((resolve, reject) => {
        const url = `/securities/overview`
        api.post(url, JSON.stringify({
            security: {
                exchange: args.exchange,
                code: args.code
            }
        }), {
            headers: {
                'Accept': 'application/x-protobuf'
            },

            responseType: 'arraybuffer'
        }).then(async (response) => {
            const decodedData = OverviewWidgetResponse.decode(new Uint8Array(response.data))
            const securityKey = getSecurityKey(args.exchange, args.code)
            overviewActions.dispatchOverviewData(
                args.dispatch,
                securityKey,
                decodedData.fieldGroups,
                decodedData.indexComponents,
                decodedData.performance,
                decodedData.communityScreens
            )
            resolve(decodedData)
        }).catch((error) => {
            reject(error)
        })
    })
}

export const getTechnicalsConfig = async (): Promise<GetTechnicalsConfigResponse> => {
    const response = await api.post(
        `/securities/technicals/config`,
        JSON.stringify({}),
        {
            headers: {
                Accept: 'application/x-protobuf'
            },
            responseType: 'arraybuffer'
        }
    )
    return GetTechnicalsConfigResponse.decode(new Uint8Array(response.data))
}

export const lookupSymbols = async (args: Array<{ exchange: Exchange | number | string; symbol: string }>) => {
    const url = '/securities/symbol-lookup'
    const securities = args
        .map(({ exchange, symbol }) => ({
            exchange: typeof exchange === 'string' || typeof exchange === 'number' ? exchangeFromJSON(exchange) : exchange,
            symbol,
        }))
        .filter(({ exchange }) => isValidExchange(exchange))

    if (!securities.length) {
        return LookupSecuritiesBySymbolResponse.fromPartial({ securities: [] })
    }

    const response = await api.post(
        url,
        JSON.stringify({
            securities: securities.map((v) => ({
                exchange: exchangeToJSON(v.exchange),
                symbol: v.symbol,
            })),
        }),
        {
            headers: {
                'Accept': 'application/x-protobuf'
            },

            responseType: 'arraybuffer'
        })

    return LookupSecuritiesBySymbolResponse.decode(new Uint8Array(response.data))

}